import { type FunctionComponent, type PropsWithChildren, createContext, useState } from 'react';
import { type SelectionMap } from '../../../types/project.types';

export enum SelectionInputType {
	GROUP = 'GROUP',
	PRODUCT = 'PRODUCT'
}

export type GroupSelectionInput = {
	type: SelectionInputType.GROUP;
	groupId: number;
};

export type SelectionInput = GroupSelectionInput | ProductSelectionInput;

export type ProductSelectionInput = {
	type: SelectionInputType.PRODUCT;
	groupId: number;
	itemId: number;
	purchased: boolean;
	showroomOnly: boolean;
	isCustomProduct: boolean;
};

export type ProjectSelectionContextState = {
	selection: SelectionMap;
	setSelection: (selection: SelectionMap) => void;
	isDeletingSelection: boolean;
	setIsDeletingSelection: (isDeleting: boolean) => void;
};

const initialState: ProjectSelectionContextState = {
	selection: {},
	setSelection: () => {},
	isDeletingSelection: false,
	setIsDeletingSelection: () => {}
};

export const ProjectSelectionContext = createContext<ProjectSelectionContextState>(initialState);

export const ProjectSelectionContextProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
	const [selection, setSelection] = useState<SelectionMap>({});
	const [isDeletingSelection, setIsDeletingSelection] = useState<boolean>(false);

	const value = {
		selection,
		setSelection,
		isDeletingSelection,
		setIsDeletingSelection
	};
	return <ProjectSelectionContext.Provider value={value}>{children}</ProjectSelectionContext.Provider>;
};
